module.exports = __webpack_public_path__ + "static/media/cidade.16859043.jpg";